module.exports = __webpack_public_path__ + "static/img/marmalade_pictgrid19_960x835.9409d91.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/marmalade_pictgrid19_960x835.jpg
// module id = BW+m
// module chunks = 0